// https://stackoverflow.com/questions/64824171/how-to-print-a-specific-element-in-vue-3

type CallbackFunction = () => void

function addStyles(win: Window, styles: string[]): void {
  styles.forEach((style) => {
    const link = win.document.createElement('link')
    link.setAttribute('rel', 'stylesheet')
    link.setAttribute('type', 'text/css')
    link.setAttribute('href', style)
    win.document.getElementsByTagName('head')[0].appendChild(link)
  })
}

interface HtmlToPaperOptions {
  styles?: string[]
}

const VueHtmlToPaper = {
  install(app: any, options: HtmlToPaperOptions = {}): void {
    app.config.globalProperties.$htmlToPaper = (
      el: string,
      localOptions?: HtmlToPaperOptions,
      cb: CallbackFunction = () => true
    ) => {
      const defaultStyles: string[] = []
      let { styles = defaultStyles } = options

      if (localOptions && localOptions.styles) {
        styles = localOptions.styles
      }

      const element = window.document.getElementById(el)

      if (!element) {
        alert(`Element to print #${el} not found!`)
        return
      }

      const ifprint = document.createElement('iframe')
      document.body.appendChild(ifprint)
      ifprint.setAttribute('style', 'height:0;width:0;')

      const win = ifprint.contentWindow

      win?.document.write(`
        <html>
          <head>
            <title>${"Hope Service Formular"}</title>
          </head>
          <body>
            ${element.innerHTML}
          </body>
        </html>
      `)

      addStyles(win as Window, styles)

      setTimeout(() => {
        win?.document.close()
        win?.focus()
        win?.print()
        win?.close()
        document.body.removeChild(ifprint)
        cb()
      }, 1)

      return true
    }
  }
}

export default VueHtmlToPaper
